import React from 'react'
import { returnIssuedBook } from "../../../../services/operations/bookDetais";
import  { useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';


function ReturnBook({issuedBook}) {

    const { token } = useSelector((state) => state.auth);

  
  
    const [returnFormData, setReturnFormData] = useState({
      bookID: "",
      libraryId: "",
      bookRetunDate: "",
    });
  
 
  
    const returnIssuedBookHandler = async (event) => {
       event.preventDefault();
  console.log(returnFormData)
        try {
       const res =  await returnIssuedBook(returnFormData, token);
       setReturnFormData({
        bookID: "",
        libraryId: "",
        bookRetunDate: "",
      });

      } catch (error) {
        console.log(error.message);
        // toast.error("Cannot issued book ");
      }

    };
    function returnissuedchangeHandler(event) {
      const { name, value, checked, type } = event.target;
      setReturnFormData((prevState) => {
        return {
          ...prevState, // copy old input field data
  
          // [event.target.name]: event.target.value
  
          // [name] :value
  
          [name]: type === "checkbox" ? checked : value,
  
          //name is a attribute
          // agar koi property acess karni he to [] bracket ke andar likhna padega
          // insrt the data of th4e current nput filed
        };
      });
    }

  return (
    <div><form onSubmit={returnIssuedBookHandler}>
    <p className={`text-center py-10 text-2xl font-mulish font-bold underline transition-all ${!issuedBook ? "opacity-100" : "opacity-0"}`}>Return Issued Book</p>
      <div className="flex lg:gap-10 flex-wrap gap-4 w-full  ">
        {/*  Student Library Id*/}
        <div className="flex flex-col space-y-2  lg:lg:w-[27%]  w-full md:w-[47%]">
          <label className="text-sm text-richblack-900" htmlFor="ilibraryId">
            Student Library Id <sup className="text-red">*</sup>
          </label>
          <input
            id="libraryId"
            name="libraryId"
            type="text"
            placeholder="Student Library Id"
            onChange={returnissuedchangeHandler}
            value={returnFormData.libraryId}
            className="two-style "
          />
        </div>
        {/* Book ID */}
        <div className="flex flex-col space-y-2  lg:lg:w-[27%]  w-full md:w-[47%]">
          <label className="text-sm text-richblack-900" htmlFor="bookID">
            Book Id <sup className="text-red">*</sup>
          </label>
          <input
            type="text"
            id="bookID"
            name="bookID"
            placeholder="Book Id"
            onChange={returnissuedchangeHandler}
            value={returnFormData.bookID}
            className="two-style "
          />
        </div>
        {/* book issued Date */}

        <div className="flex flex-col space-y-2  lg:lg:w-[27%]  w-full md:w-[47%]">
          <label
            className="text-sm text-richblack-900"
            htmlFor="bookRetunDate"
          >
           Book Return Date <sup className="text-red">*</sup>
          </label>
          <input
            id="bookRetunDate"
            name="bookRetunDate"
            type="date"
            placeholder="Student Library Id"
            onChange={returnissuedchangeHandler}
            value={returnFormData.bookRetunDate}
            className="two-style "
          />
        </div>
      </div>
      <button 
      onSubmit={returnIssuedBookHandler}
            className="bg-yellow-50 mt-7 p-2 font-mulish font-bold rounded-lg hover:bg-yellow-25 transition-all "
            type="submit"> Return Issued Book</button>
    </form></div>
  )
}

export default ReturnBook